<template>
  <div>
    <PageAllow controller="Settlements" action="requisitionMaterialView"/>
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ settlement ? settlement.name : '' }}
              <v-chip
                small
                label
                class="ms-4 mt-1"
                :color="settlement.status | settlementStatusColor"
                :text-color="settlement.status | settlementStatusTextColor"
                >{{ settlement.status | settlementStatusText }}
              </v-chip>
              <v-chip
                v-if="settlement.edit_status == 1"
                small
                label
                class="ms-4 mt-1"
                color="warning"
                text-color="white"
              >
                {{ $t("SettlementsRequisition.status.editing") }}
              </v-chip>
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <v-btn
                  v-if="$permission.permissionAllow('Settlements', 'requisitionDetailExport')"
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="download(settlement.id)"
                >
                  <v-icon x-small class="pe-1">fa-file-export</v-icon>
                  {{ $t("Receipt.bill_details_export") }}
                </v-btn>
              </v-sheet>
            </v-card-title>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style">
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("SettlementsRequisition.Fields.settlement_code") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ settlement && settlement.settlement_code ? settlement.settlement_code : "" }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("SettlementsRequisition.Fields.receive_settlement") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ settlement && settlement.receive_entity_name ? settlement.receive_entity_name : "" }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("SettlementsRequisition.Fields.pay_settlement") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ settlement && settlement.pay_entity_name ? settlement.pay_entity_name : "" }}
                  </span>
                </v-card>
              </v-col>

              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("SettlementsRequisition.Fields.created") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ settlement ? settlement.created : "" | formatTime }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("SettlementsRequisition.Fields.fee") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("Global.money") }}{{ $numberFormatter.formatMoneyFloor(settlement ? settlement.fee : "", true) }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("SettlementsRequisition.Fields.paid") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("Global.money") }}{{ $numberFormatter.formatMoneyFloor(settlement ? settlement.paid : "", true) }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("SettlementsRequisition.Fields.wait_receive") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("Global.money") }}{{ $numberFormatter.formatMoneyFloor(settlement ? settlement.wait_receive : "", true) }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("SettlementsShop.Fields.logistics_fee") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    <a class="text-no-wrap" @click.stop="dialogLogisticID = settlement.id">
                      {{ $t("Global.money") }}{{ $numberFormatter.formatMoneyFloor(settlement ? settlement.logistics_fee : "", true) }}
                    </a>
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("SettlementsShop.Fields.service_charge") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                     <a class="text-no-wrap" @click.stop="dialogServiceID = settlement.id">
                      {{ $t("Global.money") }}{{ $numberFormatter.formatMoneyFloor(settlement ? settlement.service_charge : "", true) }}
                    </a>
                  </span>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab @click.stop="tab = 0; panels.find((p) => p == 1) ? null : panels.push(1);">
                {{ $t("SettlementsShop.activities") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="activitiesHeaders"
                    :items="order_activities"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-card class="mt-4">
        <v-card-title>
          {{ $t("RequisitionMaterialView.title") }}
        </v-card-title>
        <!-- 明细/编辑 -->
        <v-data-table
          :headers="detailsHeaders"
          :items="materialDetails"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          disable-sort
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent-background-color" align-self="center">
              <v-row no-gutters class="me-n3">
                <span class="caption secondary--text pt-2">
                  {{ $t("$vuetify.dataFooter.pageText", paging ? [1, paging.current, paging.count,] : [0, 0, 0]) }}
                </span>
                <v-row no-gutters>
                  <v-spacer />
                  <v-col cols="12" sm="6" md="4">
                    <SearcherKeyword
                      v-model="options.keyword"
                      @text="filter = $event"
                      clearable
                      hide-details
                      :label="$t('Search.filter')"
                    />
                  </v-col>
                </v-row>
              </v-row>
            </v-toolbar>
          </template>
          <!-- 合计 -->
          <template v-slot:body.prepend>
            <tr class="d-none d-sm-table-row">
              <td>
                <span>{{ $t("TableSum") }}</span>
              </td>
              <td colspan="7"></td>
              <td>{{ $t("Global.money") }}{{ totalPrice | formatMoneyFloor(true) }}</td>
              <td></td>
            </tr>
          </template>
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.material_name="{ item }">
            <a
              class="text-no-wrap"
              @click.stop="dialogMaterialID = item.material_id"
            >
              {{ item.material_name }}
            </a>
          </template>
          <template v-slot:item.standard_name="{ item }">
            <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
              {{ item.standard_name.slice(0, 12) + "......" }}
            </span>
            <span v-else>
            {{ item.standard_name }}
            </span>
          </template>
          <template v-slot:item.price="{ item }">
            {{ $t("Global.money") }}{{ item.price | formatMoneyFloor(true) }}
          </template>
          <template v-slot:item.total="{ item }">
            {{ $t("Global.money") }}{{ item.total | formatMoneyFloor(true) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip
              top
              v-if="$permission.permissionAllow('Settlements', 'detailByMaterial')"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    currentMaterial = item;
                    detailDialog = true;
                  "
                >
                  {{ $t("ShopMaterialView.Fields.detail") }}
                </v-btn>
              </template>
              <span>{{ $t("ShopMaterialView.Fields.detail") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
    </v-sheet>
    <MaterialDialog v-model="dialogMaterialID" />
    <SettlementLogisticDialog v-model="dialogLogisticID" />
    <SettlementServiceChargeDialog v-model="dialogServiceID" />
    <SettlementMaterialDialog v-model="detailDialog" :currentItem="currentMaterial" :type="settlement.type" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Settlements from "@/api/settlements";
import MaterialDialog from "@/components/materials/plugins/Dialog";
import SettlementMaterialDialog from "@/components/plugins/SettlementMaterialDialog";
import SettlementLogisticDialog from "@/components/plugins/SettlementLogisticDialog.vue";
import SettlementServiceChargeDialog from "@/components/plugins/SettlementServiceChargeDialog.vue";
import SearcherKeyword from "@/components/plugins/SearcherKeyword.vue";

export default {
  components: {
    SearcherKeyword,
    PageAllow,
    Breadcrumbs,
    MaterialDialog,
    SettlementLogisticDialog,
    SettlementServiceChargeDialog,
    SettlementMaterialDialog,
  },

  computed: {
    items() {
      let items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.settlements"),
          disabled: false,
          href: "/settlements-requisition",
        },
        {
          text: i18n.t("Nav.settlementsRequisition"),
          disabled: false,
          href: "/settlements-requisition",
        },
        {
          text: i18n.t("RequisitionMaterialView.title"),
          disabled: true,
          href: "/settlements-requisition",
        },
      ];
      return items;
    },
    detailsHeaders() {
      let headers = [];
      headers.push(
        {
          text: i18n.t("RequisitionMaterialView.Fields.category_name"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("RequisitionMaterialView.Fields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("RequisitionMaterialView.Fields.material_name"),
          align: "start",
          value: "material_name",
        },
        {
          text: i18n.t("RequisitionMaterialView.Fields.unit"),
          align: "start",
          value: "unit",
        },
        {
          text: i18n.t("RequisitionMaterialView.Fields.standard_name"),
          align: "start",
          value: "standard_name",
        },
        {
          text: i18n.t("RequisitionMaterialView.Fields.order_num"),
          align: "start",
          value: "order_num",
        },
        {
          text: i18n.t("RequisitionMaterialView.Fields.bill_num"),
          align: "start",
          value: "bill_num",
        },
        {
          text: i18n.t("RequisitionMaterialView.Fields.price"),
          align: "start",
          value: "price",
        },
        {
          text: i18n.t("RequisitionMaterialView.Fields.total"),
          align: "start",
          value: "total",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "actions",
        },
      );
      return headers;
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("SettlementsShop.ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("SettlementsShop.ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("SettlementsShop.ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "accountUser"]),
  },

  data: () => ({
    panels: [0],
    options: {},
    paging: {},
    settlement: [],
    materialDetails: [],
    dialogLogisticID: null,
    dialogServiceID: null,
    dialogMaterialID: null,
    detailDialog: false,
    currentMaterial: null,
    totalPrice: 0,
    filter: '',
    order_activities: [],
    tab: null,
  }),

  mounted() {
    this.getSettlementsRequisitionMaterialsFromAPI()
    this.getMaterialListForPaginate()
  },

  methods: {
    getSettlementsRequisitionMaterialsFromAPI() {
      Settlements.fetchRequisitionMaterial(this.$route.params.id, {order_activity: 1}).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.settlement = response.data.settlement;
            this.order_activities = response.data.order_activities;
          }
        }.bind(this)
      );
    },
    getMaterialListForPaginate() {
      let postData = Object.assign({}, this.options, {
        id: this.$route.params.id
      });
      Settlements.getMaterialListForPaginate(postData).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.totalPrice = response.data.total_price;
            this.materialDetails = response.data.settlement_materials
            this.paging = response.data.paging
          }
        }.bind(this)
      )
    },
    download(id) {
      Settlements.requisitionDetailExport(id);
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getMaterialListForPaginate();
      },
    },
  },
};
</script>